export const WORKFLOWS_PAGE_NS = 'pages/WorkflowsPage';

export const i18n = {
  en: {
    titles: {
      buildWorkflow: 'Start building your first workflow',
      draftFlow: 'Draft flow',
      craftWorkflow: 'We’re crafting your workflows. Almost there!',
    },
    descriptions: {
      checkKnowledgeBase: 'Check our Knowledge Base to learn more',
      buildWorkflow:
        'Build your multi-party workflow in minutes and create highly connected, trust-based ecosystems that operate at a global scale.',
      workflowAvailability:
        'The workflow builder is currently only available on tablet or desktop. We are working on a mobile version to provide a better experience.',
      craftWorkflow: 'It could take up to 30 seconds',
    },
    buttons: {
      workflowBuilder: 'Build my first workflow',
      takeATour: 'Take a tour',
    },
    tutorialModal: {
      stepActions: {
        prev: 'Prev',
        next: 'Next',
        skip: 'Skip',
        done: 'Done',
      },
    },
    actions: {
      edit: 'Edit workflow',
      continueEditing: 'Continue Editing',
      showVersion: 'Show workflow version',
    },
    entityGroupCard: {
      totalItems: 'items',
    },
  },
};
